import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ValidationlogComponent } from './validationlog.component';

const routes: Routes = [{ path: '', component: ValidationlogComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ValidationlogRoutingModule { }
